// Lib
import { connect } from 'react-redux';
import * as Immutable from 'immutable';
import { createStructuredSelector, createSelector } from 'reselect';
import { compose } from '../../../../node_module_clones/recompose';

// Measurements
import measurementsConnect from '../../measurementsStore/measurementsConnect';

// Utils
import { asObject, isEmpty } from '../../../../common/utils/immutableHelper';
import { transformMeasurementsInPlace } from '../../measurementsStore/elementMeasurements/utils/measureElementZoomUtils';

// Selectors
import { selectIsMobileAppMode } from '../../../platform/platformSelector';
import { getPoiCurrentBoardId, getPoiMap, getPoiSection, getPoiType } from '../poiSelector';
import { createShallowSelector } from '../../../utils/milanoteReselect/milanoteReselect';
import { elementFilterTypeSelector } from '../../../element/elementFilter/elementFilterSelector';
import { canvasZoomStateSelector } from '../../../canvas/store/canvasZoomSelector';

// Constants
import { BoardSections } from '../../../../common/boards/boardConstants';
import { ELEMENT_FILTER_TYPES } from '../../../element/elementFilter/elementFilterConstants';
import { PoiType } from '../poiConstants';

export const mapStateToProps = createStructuredSelector({
    filterType: elementFilterTypeSelector,
    zoomState: canvasZoomStateSelector,
    isMobileAppMode: selectIsMobileAppMode,
});

/**
 * Transform the points of interest depending on the current zoom state.
 */
const getTranslatedPoiMap = createShallowSelector(
    getPoiMap,
    (state, { zoomState }) => zoomState,
    (poiMap, zoomState) =>
        poiMap.map((poiEntry) => {
            const entry = asObject(poiEntry);
            transformMeasurementsInPlace(entry.targetRect, zoomState);
            return entry;
        }),
);

const getUnseenCanvasPois = createShallowSelector(
    getTranslatedPoiMap,
    (state, { filterType }) => filterType,
    (state, { currentBoardId }) => currentBoardId,
    (poiMap, filterType, currentBoardId) =>
        poiMap.filter((poi) => {
            // This is required to prevent POIs from the wrong boards from being displayed
            // This happens due to the batch middleware - meaning the removal of POIs lag the render of
            // a board that's just been navigated to.
            const poiCurrentBoardId = getPoiCurrentBoardId(poi);

            if (poiCurrentBoardId !== currentBoardId) return false;

            const isCanvas = getPoiSection(poi) === BoardSections.CANVAS;

            if (!isCanvas) return false;

            return !(filterType === ELEMENT_FILTER_TYPES.SEARCH) || getPoiType(poi) === PoiType.search;
        }),
);

const EMPTY_MAP = Immutable.Map();

/**
 * We only show search POI pointers on mobile - so don't perform the Unseen canvas POIs calculation
 * unless we're not on mobile, or we're doing a search.
 */
const selectPointerLayerPois = (state, props) => {
    const { isMobileAppMode, filterType } = props;

    if (isMobileAppMode && filterType !== ELEMENT_FILTER_TYPES.SEARCH) return EMPTY_MAP;

    return getUnseenCanvasPois(state, props);
};

const mapMeasurementsStateToProps = createSelector(selectPointerLayerPois, (pointersMap) => ({
    pointersActive: !isEmpty(pointersMap),
    pointersMap,
    pointers: pointersMap.valueSeq().toJS(),
}));

export default compose(connect(mapStateToProps), measurementsConnect(mapMeasurementsStateToProps));
